//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteCustomFieldInputItem } from './WebsiteCustomFieldInputItem';
import { WebsiteBlockType } from './Enums';

export class WebsiteCustomFieldContactFormInputItem extends WebsiteCustomFieldInputItem {
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.ContactForm;

    constructor(initializer?: Partial<Omit<WebsiteCustomFieldContactFormInputItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteCustomFieldContactFormInputItem";
}
